import {
  LoggingServicePort,
  PerformancePort,
  UserTimingPort,
} from '../../ports'

export class PerformanceTrackingWithFractionalLoggingAdapter {
  private static readonly INVALID_METRIC_VALUE = -1

  constructor(
    private readonly loggingService: LoggingServicePort,
    private readonly userTiming: UserTimingPort,
    private readonly performance: PerformancePort
  ) {}

  markPerformanceMetric(performanceMetric: string): void {
    this.performance.mark(performanceMetric)
  }

  sendMeasurement(
    startMetric: string,
    finishedMetric: string,
    metricName: string
  ): void {
    const calculatedPerformanceTime = this.calculatePerformanceTime(
      startMetric,
      finishedMetric
    )

    this.sendPerformanceMetric(metricName, calculatedPerformanceTime)
  }

  private calculatePerformanceTime(
    startMetric: string,
    endMetric: string
  ): number {
    try {
      const start = this.performance.getEntriesByName(startMetric)[0]?.startTime
      const end = this.performance.getEntriesByName(endMetric)[0]?.startTime

      if (typeof start === 'undefined' || typeof end === 'undefined') {
        return PerformanceTrackingWithFractionalLoggingAdapter.INVALID_METRIC_VALUE
      }

      return Math.round(end - start)
    } catch (error) {
      this.loggingService.logError(
        new Error(`Error calculating performance time:`, { cause: error })
      )
      return PerformanceTrackingWithFractionalLoggingAdapter.INVALID_METRIC_VALUE
    }
  }

  private sendPerformanceMetric(
    performanceMetricName: string,
    performanceMetricValue: number
  ): void {
    if (
      performanceMetricValue ===
      PerformanceTrackingWithFractionalLoggingAdapter.INVALID_METRIC_VALUE
    ) {
      this.loggingService.logError(
        new Error(
          `Unable to send performance metric: ${performanceMetricName}, invalid performance metric value: ${performanceMetricValue}`
        )
      )
      return
    }
    try {
      this.performance.mark(performanceMetricName)
      this.userTiming.sendBeacon({
        [performanceMetricName]: performanceMetricValue,
      })
    } catch (error) {
      this.loggingService.logError(
        new Error(
          `Error sending performance metric: ${performanceMetricName}`,
          { cause: error }
        )
      )
    }
  }
}
